import {
  normalizeCommonFields,
  createActualBlockName,
  ActualNameCreator
} from '../common';

import { ActionExecuteSqNormalizer, IActionExecuteSqParams } from './client';

const createActionExecuteSqActualNameBase = (expr: string): string => {
  return expr;
};

export const createActionExecuteSqActualName: ActualNameCreator<
  IActionExecuteSqParams
> = ({ params }) => createActionExecuteSqActualNameBase(params.condition.expr);

export const normalizeActionExecuteSq: ActionExecuteSqNormalizer = (
  raw,
  stores
) => {
  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: createActionExecuteSqActualNameBase(raw.params.expr),
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
